(function () {

    /**
     * JavaScript Graphical User Interface
     * Simple Template implementation
     *
     * @author Eugene Lyulka
     * @version 2.0
     * @namespace GUI
     *
     * @param {String} tpl Template
     * @param {Object} bind
     */
    GUI.STemplate = function stmpl(tpl, bind) {
        var template = tpl,
            tagRe = /\{(.*?)\}/gm,
            self = {};

        /**
         * Replacer
         * @param {Object} match
         * @param {String} name
         */
        function replacer(match, name) {
            if (name.indexOf('.')) {
                var tree = name.split('.', 10),
                    curName = tree.shift(),
                    i = tree.length,
                    t, curr;

                curr = (curName === 'this') ? bind : self[curName];

                while (i--) {
                    if (typeof curr === 'undefined') {
                        return 'undefined';
                    }

                    t = tree.shift();

                    if (t.search('get') === 0 && t.search('()') !== -1) {
                        curr = curr[t.replace('()', '')]();
                    } else {
                        curr = curr[t];
                    }
                }
                return curr;
            } else {
                return self[name];
            }
        }

        self.fetch = function () {
            return template.replace(tagRe, replacer);
        };

        self.bind = function (to) {
            bind = to;
        };

        return self;
    };

}());

// Simple JavaScript Templating
// Originally written by John Resig - http://ejohn.org/ - MIT Licensed
// Modified version by Eugene Lyulka
(function () {
    var cache = {},
        getCompiledCode;

    if (GUI.isIE) {
        getCompiledCode = function (str) {
            var funcCode = "var p=[],obj=obj||{},print=function () {p.push.apply(p,arguments);};" +
            // Introduce the data as local variables using with() {}
                    "with(obj) {p.push('" +

            // Convert the template into pure JavaScript
                    str
                    .replace(/[\r\t\n]/g, " ")

                    .replace(/'(?=[^%]*%>)/g, "\t")
                    .split("'").join("\\'")
                    .split("\t").join("'")
                    .replace(/<%=(.+?)%>/g, "',$1,'")
                    .split("<%").join("');")

                    .split("%>").join("p.push('")
                    .split("\r").join("\\'")
                    + "');}return p.join('');";
            return funcCode;
        };
    } else {
        getCompiledCode = function (str) {
            var funcCode = "var p='',obj=obj||{},print=function () {p = p.concat.apply(p,arguments);};" +
            // Introduce the data as local variables using with() {}
                     "with(obj) {p+='" +

                // Convert the template into pure JavaScript
                     str
                    .replace(/[\r\t\n]/g, " ")

                    .replace(/'(?=[^%]*%>)/g, "\t")
                    .split("'").join("\\'")
                    .split("\t").join("'")
                    .replace(/<%=(.+?)%>/g, "'+$1+'")
                    .split("<%").join("';")

                    .split("%>").join("p+='")
                    .split("\r").join("\\'")
                    + "';}return p;";
            return funcCode;
        };
    }

    /**
     * JavaScript Graphical User Interface
     * Template implementation
     *
     * @author Eugene Lyulka
     * @version 2.0
     * @namespace GUI
     *
     * @param {Stirng} str
     * @param {Object} data
     * @param {Number|String} cacheId
     */

    GUI.Template = function tmpl(str, data, cacheId) {
        // Figure out if we're getting a template, or if we need to
        // load the template - and be sure to cache the result.
        if (cacheId) {
            fn = cache[cacheId] = cache[cacheId] || GUI.Template(str);
        } else {
            // Generate a reusable function that will serve as a template
            // generator (and which will be cached).
            var funcCode = getCompiledCode(str);
            try {
                fn = new Function("obj", funcCode);
            } catch (e) {
                console.log('Error compiling template, generated code: ' + funcCode);
                return null;
            }
        }
        // Provide some basic currying to the user
        return data ? fn(data) : fn;
    };

}());

